<template>
  <nd-dialog
    v-model="visible"
    :close-btn="!isRsllApi"
    :footer="false"
  >
    <div class="dialog-box">
      <div class="box-logo">
        <img src="./images/logo@2x.png" class="logo">
        <div class="logo-text">天美贷 | 合规低息</div>
      </div>
      <div class="rsll-api" v-if="isRsllApi">
        <div class="title">请关注<span class="text-primary">公众号进入{{ jumpPosition.name }}</span></div>
        <div class="title">立领50000元提现额度</div>
        <div class="close-btn" @click="closeAction">
          <img src="https://static.ndmicro.com/tmd/landing/components/images/btn_close.png">
        </div>
        <div class="type1">
          <img src="./images/img_01@2x.png">
        </div>
        <div class="type2">
          <img :src="jumpPosition.link" class="box-img">
        </div>
      </div>
      <template v-else>
        <div class="box-title">请关注公众号进入{{ jumpPosition.name }}</div>
        <div class="box-subTitle">立领<span class="text-primary">50000</span>元提现额度</div>
        <img :src="jumpPosition.link" class="box-img">
        <div class="box-btn">长按保存图片至相册</div>
        <div class="box-tips">
          <div class="tips-item">保存图片至相册，使用微信扫一扫功能识别二维码图片，关注公众号</div>
          <div class="tips-item">微信搜索公众号——{{ jumpPosition.name }}，即可关注</div>
        </div>
      </template>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'IosDownload',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  mounted () {
   
  },
  computed: {
    isRsllApi () {
      return this.$route.query.channel === 'API-rsll' && this.jumpPosition.name === '天美贷'
    },
    visible: {
      get () {
        if (this.value) {
          this.getAppInfo()
        }
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    closeAction () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.dialog-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px 40px;
  color: #333333;
  .close-btn {
    position: absolute;
    right:40px;
    top:40px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .rsll-api {
    padding-top: 30px;
    .title  {
      font-size: 32px;
      font-weight: bold;
      text-align: center;
    }
    .type1 {
      margin-top: 20px;
    }
    .type2 {
      margin-top: 10px;
      width:560px;
      height:412px;
      background: url(./images/img_02@2x.png) no-repeat center;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 20px;
      img {
        width: 250px;
        height: 250px;
      }
    }
  }
  .box-logo{
    font-size: 26px;
    display: flex;
    align-items: center;
    align-self: flex-start;
    .logo{
      width: 40px;
      height: 40px;
      margin-right: 7px;
    }
  }
  .box-title{
    margin-top: 60px;
    font-size: 32px;
    font-weight: bold;
  }
  .box-subTitle {
    font-size: 32px;
    font-weight: bold;
  }
  .box-img{
    margin-top: 10px;
    width: 430px;
  }
  .box-tips{
    font-size: 26px;
    color: #666666;
    line-height: 41px;
    margin-top: 30px;
    .tips-item{
      counter-increment: number;
      position: relative;
      padding-left: 1.5em;
      &::before{
        content: counter(number) + "、";
        display: inline-block;
        position: absolute;
        left: 0;
      }
    }
  }
  .box-btn{
    font-size: 32px;
    margin-top: 10px;
    font-weight: bold;
  }
}
.text-primary {
  color: #FF4633
}
</style>